export default "__VITE_ASSET__c2fc1f84__"